// US phone formatting, shared by the public site's marketing bundle and the
// dashboard's phone-mask Stimulus controller so a phone field looks the same
// wherever it appears. This is the only place the mask is defined, the way
// lib/date_picker.js is the only place the calendar is configured.
//
// Presentation only. The field posts whatever it shows, and the staff area
// re-formats on the way out through PhoneHelper#format_phone, which strips
// punctuation first and so accepts anything a parent typed.
//
// The caret restore this needs is the same one every fixed digit mask needs, so
// it lives in lib/digit_mask.js and this file supplies only the format.

import { maskDigitInput } from "./digit_mask";

// "8015551234" and "(801) 555-1234" and "+1 801 555 1234" all come back as
// "(801) 555-1234". Anything shorter formats as far as it can, so the mask can
// run on every keystroke while a number is still half typed.
export const formatPhone = (value) => {
  let digits = String(value).replace(/\D/g, "");
  // A pasted "+1 801 555 1234" arrives as eleven digits. Dropping the country
  // code keeps the slice below from cutting the last digit off a real number.
  if (digits.length === 11 && digits.startsWith("1")) digits = digits.slice(1);
  digits = digits.slice(0, 10);

  if (digits.length >= 7) return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  if (digits.length >= 4) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  if (digits.length >= 1) return `(${digits}`;
  return "";
};

export const maskPhoneInput = (input) => maskDigitInput(input, formatPhone);

// What a half-typed number is told. The mask formats as far as it can, so
// "(801) 555" looks like a real field to the browser's own checks and passed the
// registration form's step gate; the model then refused it at Send, one step and
// a scroll away from the field. The same words as Registration::PHONE_MESSAGE, so
// the browser and the server say one thing. An empty field says nothing here: an
// empty required field is the `required` attribute's to report, and an empty
// optional one is fine.
export const PHONE_SHORT_MESSAGE = "Use a ten-digit number, like (801) 555-1234";

export const phoneValidityMessage = (value) => {
  const digits = String(value).replace(/\D/g, "");
  return digits.length === 0 || digits.length >= 10 ? "" : PHONE_SHORT_MESSAGE;
};
